import { useTranslation } from 'react-i18next';

interface YoutubeCMSDescriptionProps {
  className?: string;
}

export const YoutubeCMSDescription = (props: YoutubeCMSDescriptionProps) => {
  const { t } = useTranslation();

  return (
    <p className="mt-(-14px) mb-8 px-4 text-md text-tertiary" {...props}>
      {t('youtubeCMSDescription')}
    </p>
  );
};
